<template>
    <div class="personnel">
        <Head-view :showStyle="1"></Head-view>
        <div class="main">
            <div class="breadcrumb">人员管理</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="fontName">名字</div>
                    <div class="searchInp">
                        <el-input
                            v-model="searchVal"
                            prefix-icon="el-icon-search"
                            placeholder="请输入"
                        ></el-input>
                    </div>
                    <div class="departName">部门</div>
                    <div class="searchInp">
                        <el-select
                            v-model="depVal"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in depArr"
                                :key="item.deptId"
                                :label="item.name"
                                :value="item.deptId"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="searchBtn" @click="searchBtn()">搜索</div>
                </div>
                <div class="institutionAddBtn" @click="addInstitution()">
                    新建人员
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        v-loading="loading"
                        stripe
                    >
                        <el-table-column prop="date" label="头像" width="170">
                            <template slot-scope="scope">
                                <div class="headImg">
                                    <img
                                        v-if="scope.row.portrait"
                                        :src="scope.row.portrait"
                                        alt=""
                                    />
                                    <img
                                        v-if="!scope.row.portrait"
                                        src="../../assets/defaultHead.png"
                                        alt=""
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="staffNumber"
                            label="账号"
                            width="190"
                        >
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" width="170">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            label="联系电话"
                            width="190"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="联系地址"
                            width="300"
                        >
                        </el-table-column>
                        <el-table-column prop="dept" label="部门" width="200">
                        </el-table-column>
                        <el-table-column prop="role" label="角色" width="200">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="colorBulr"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    class="colorRed"
                                    @click="removeInst(scope.$index, scope.row)"
                                    >删除</el-button
                                >
                                <el-button
                                    class="colorBulr"
                                    type="text"
                                    size="small"
                                    @click="replacePassword(scope.row)"
                                    >重置密码</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageObj.currentPage"
                        :page-sizes="pageObj.pageSizeArr"
                        :page-size="pageObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog
            title="重置员工密码"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <div class="changePassword">
                <div class="userNum">账号： {{ userNum }}</div>
                <div class="from">
                    <div class="title">新密码</div>
                    <div class="fromInp">
                        <el-input
                            type="password"
                            v-model="newPassword"
                            placeholder="请输入"
                            @blur="trimBoth('newpassword', newPassword)"
                        ></el-input>
                    </div>
                </div>
                <div class="from">
                    <div class="title">重新输入新密码</div>
                    <div class="fromInp">
                        <el-input
                            type="password"
                            v-model="newPasswords"
                            placeholder="请输入"
                            @blur="trimBoth('newpasswords', newPasswords)"
                        ></el-input>
                    </div>
                </div>
            </div>
            <div class="towImgFont"></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="replacePasswordComfim()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "personnel",
    data() {
        return {
            searchVal: "",
            depVal: "",
            depArr: [],

            tableData: [],

            options: [],

            insId: "",

            pageObj: {
                currentPage: 1,
                pageSizeArr: [10, 40, 100, 400],
                pageSize: 10,
                total: 0,
            },

            loading: true,

            userNum: "",
            newPassword: "",
            newPasswords: "",

            dialogVisible: false,
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));

        this.userRole = localStorage.getItem("userRole")
        this.personnelInfo();
        this.getdepInfo();
    },

    methods: {
        personnelInfo(searchFlag = false) {
            this.loading = true;

            if (this.searchVal != '' && searchFlag) {
                this.pageObj.currentPage = 1
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                keyword: this.searchVal,
                deptId: this.depVal == "" ? "-1" : this.depVal,
                page: this.pageObj.currentPage,
                limit: this.pageObj.pageSize,
            };
            this.request
                .post(this.baseUrl + "/institution/getStaffList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.tableData = res.data.list;
                        this.pageObj.total = res.data.totalCount;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message({
                        type: "warning",
                        message: "查询人员失败",
                    });
                });
        },

        getdepInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getDeptList", data)
                .then((depRes) => {
                    if (depRes.code == 0) {
                        this.depArr = depRes.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: depRes.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        searchBtn() {
            this.personnelInfo(true);
        },

        addInstitution() {
            this.$router.push("/personnel/personnelAdd");
        },
        handleSizeChange(val) {
            this.pageObj.pageSize = val;
            this.personnelInfo();
        },
        handleCurrentChange(val) {
            this.pageObj.currentPage = val;
            this.personnelInfo();
        },
        handleEide(index, row) {
            let userNum = row.staffNumber.substr(row.staffNumber.length -2)
            
            if (userNum == '01' && row.staffNumber.length <= 7 && this.userRole != 1) {
                return this.$message({
                    type: 'warning',
                    message: "账号权限不足，不可对该账号更改"
                })
            }
            this.$router.push({
                path: "/personnel/personnelAdd",
                query: {
                    id: row.staffId,
                    userNum: row.staffNumber,
                },
            });
        },
        replacePassword(row) {
            if (this.userRole != '1') {
                return this.$message({
                    type: 'warning',
                    message: "账号权限不足，请联系超级管理员重置密码"
                })
            }
            //重置密码
            this.dialogVisible = true;
            this.userNum = row.staffNumber;
            this.newPassword = "";
            this.newPasswords = "";
        },

        replacePasswordComfim() {
            //重置密码
            if (!this.newPassword || !this.newPasswords) {
                return this.$message({
                    type: "warning",
                    message: "密码不能为空",
                });
            } else if (this.newPassword != this.newPasswords) {
                return this.$message({
                    type: "warning",
                    message: "两次输入的密码不一致",
                });
            }

            let data = {
                token: this.getCookie(),
                username: this.userNum,
                newPassword: this.newPassword,
            };

            this.request
                .post(this.baseUrl + "account/resetStaffPassword", data)
                .then((res) => {
                    if (res.code == 0 && res.data.result) {
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.dialogVisible = false;
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "出错了，修改失败",
                    });
                });
        },

        trimBoth(type, val) {
            let trimVal = val.trim();

            switch (type) {
                case "newPassword":
                    this.newPassword = trimVal;
                    break;
                case "newPasswords":
                    this.newPasswords = trimVal;
                    break;
            }
        },

        removeInst(index, row) {
            let userNum = row.staffNumber.substr(row.staffNumber.length -2)
            if (userNum == '01') {
                return this.$message({
                    type: 'warning',
                    message: "账号权限不足，不可对该账号进行删除操作"
                })
            }
            let userData = {
                token: this.getCookie(),
                staffId: row.staffId,
            };
            this.request
                .post(this.baseUrl + "task/getStaffCurrentTaskCount", userData)
                .then((taskRes) => {
                    if (taskRes.code == 0 && taskRes.data.taskCount >= 1) {
                        this.$confirm("该人员有" + taskRes.data.taskCount + "条巡检任务，是否取消关联", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        }).then(() => {
                            this.delectPersonnel(row)
                        }).catch(() =>{})
                    } else if (taskRes.code == 0 && taskRes.data.taskCount < 1) {
                        this.delectPersonnel(row)
                    } else {
                        this.$message({
                            type: "warning",
                            message: taskRes.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "出错，获取任务数失败",
                    });
                });
        },

        delectPersonnel(row) {
            this.$confirm("确定要删除该人员吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        staffId: row.staffId,
                    };
                    this.request
                        .post(this.baseUrl + "institution/deleteInsStaff", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.personnelInfo()
                                this.$message({
                                    type: "success",
                                    message: "删除成功",
                                });
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "删除失败",
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message({
                                type: "error",
                                message: "出错，删除失败",
                            });
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style lang="less" scoped>
.personnel {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 68px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                display: flex;
                flex-direction: row;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                .fontName {
                    width: 44px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    line-height: 40px;
                }
                .searchInp {
                    width: 211px;
                }
                .departName {
                    width: 64px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: center;
                    line-height: 40px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .institutionAddBtn {
                margin: 14px 17px 0 0;
                float: right;
                width: 95px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;
                .headImg {
                    width: 32px;
                    height: 32px;
                    border-radius: 45px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
        }

        .colorRed {
            color: rgba(255, 87, 51, 1);
        }

        .colorBulr {
            color: rgba(25, 137, 250, 1);
        }
    }

    .changePassword {
        width: 406px;
        .userNum {
            margin-bottom: 16px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 85, 86, 1);
        }

        .from {
            margin-bottom: 16px;
            display: flex;
            flex-direction: row;
            .title {
                width: 122px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(84, 85, 86, 1);
                line-height: 40px;
            }

            /deep/ .el-input__inner {
                width: 268px;
            }
        }
    }
}
</style>